import {
  AlertCircle,
  AlertTriangle,
  ArrowRight,
  Calculator,
  Info,
  CircleDashed,
  Archive,
  BarChart3,
  Bell,
  BookDashed,
  BookOpen,
  Calendar,
  CalendarClock,
  CheckCircle2,
  ClipboardList,
  Clock,
  Coins,
  Database,
  Eye,
  FileText,
  Gauge,
  GraduationCap,
  HardDriveDownload,
  HelpCircle,
  Inbox,
  KeyRound,
  LayoutTemplate,
  LifeBuoy,
  Lock,
  MousePointerClick,
  NotebookPen,
  type LucideIcon,
  Megaphone,
  MessageSquare,
  Plug,
  ScrollText,
  Settings,
  Siren,
  ShieldAlert,
  ShieldCheck,
  Plus,
  Sparkles,
  ScanSearch,
  Terminal,
  Timer,
  TrendingDown,
  UserCheck,
  UserCog,
  Users,
  Wallet,
  House,
  Menu,
  LogOut,
  Gift,
  ChevronDown,
  CircleUser,
  MessageCircleMore,
  ListChecks,
  ChartNoAxesColumn,
  Target,
  Radio,
  ClipboardCheck,
  Presentation,
  Contact,
  MessageSquareLock,
  Building2,
  SquarePen,
  FileDown,
  Trash2,
  Funnel,
  Trophy,
  ShoppingBag,
  RefreshCw,
  Store,
} from "lucide-react";
import { cn } from "./cn";

/**
 * IKON — adlandirilmis, KAPALI bir set.
 *
 * ================================================================
 * IKON TEK BASINA ANLAM TASIMAZ
 * ================================================================
 * Bu, rengin kuralinin aynisi (`Kart.tsx` "kenar rengi tek sinyal
 * degil"). Bir ikon her zaman METNIN YANINDA durur; yerine gecmez.
 * Sebepleri:
 *
 *   - Ikon dili evrensel degil. Bir "kalkan" kime guvenlik, kime
 *     engelleme cagristirir; yanindaki kelime bunu tartismaya
 *     kapatir.
 *   - Ekran okuyucu ikonu okumaz. Bu yuzden hepsi `aria-hidden`:
 *     duyurulacak sey metnin kendisi.
 *   - Ogrenen kullanici ikonu tanir ve hizlanir; YENI kullanici
 *     metni okur. Ikonsuz metin yavas, metinsiz ikon bilmece.
 *
 * ================================================================
 * NEDEN KAPALI SET
 * ================================================================
 * `lucide-react` bin kusur ikon tasiyor. Dogrudan import edilseydi
 * ayni kavram iki ekranda iki farkli ikonla cizilirdi — "ogrenci"
 * biri icin `Users`, oteki icin `GraduationCap` olurdu ve bunu kimse
 * fark etmezdi.
 *
 * Burasi sozluk: kavram -> ikon eslesmesi TEK yerde. Yeni bir kavram
 * eklemek, sozluge bir satir eklemek demek; ayni ikonu iki kavrama
 * vermek ise gozle gorulur hale geliyor.
 */
export const IKONLAR = {
  // --- Ogrenci ve akademik ---
  bugun: Gauge,
  program: CalendarClock,
  ogrenci: Users,
  deneme: ClipboardList,
  rapor: FileText,
  mufredat: BookOpen,
  risk: TrendingDown,

  // --- Satis ve gorusme ---
  aday: UserCheck,
  gorusme: MessageSquare,

  // --- Operasyon ---
  takvim: Calendar,
  duyuru: Megaphone,
  talep: LifeBuoy,
  onay: CheckCircle2,

  // --- Finans ---
  finans: Wallet,
  abonelik: Coins,

  // --- Yonetim ve sistem ---
  log: ScrollText,
  rol: ShieldCheck,
  /*
    Guvenlik konsolu — `rol` (ShieldCheck) DEGIL. Ikisi de kalkan ama
    anlattiklari ayri: `rol` "yetki verildi, dogrulandi" diyor;
    guvenlik konsolu sistemin savunmasini yoneten yer ve orada
    ONAYLANMIS bir hal yok, izlenen bir hal var. Ikon testi zaten iki
    kavramin ayni ikonu paylasmasini yasakliyor.
  */
  guvenlik: ShieldAlert,
  kvkk: KeyRound,
  gorunum: Eye,
  /*
    ================================================================
    ZİL `bildirim`E GEÇTİ — ŞABLON ŞABLON İKONU ALDI (07.09.2026)
    ================================================================
    `sablon` (bildirim şablonları) zili taşıyordu ve bildirimin
    KENDİSİ hiçbir ikona sahip değildi. F-NTF-09'un gelen kutusu
    öğrenci uygulamasına da açılınca ikona ihtiyaç oldu ve zil orada
    olmalıydı: kullanıcı zili "bildirim" diye okur, "bildirimin
    metin şablonu" diye değil.

    İkinci bir zil türevi (`BellRing`) eklenmedi — bu setin kuralı
    iki kavramın ayrı ikon taşıması ve birbirine bakan iki zil, tam
    da kuralın engellediği karışıklığı üretirdi.
  */
  bildirim: Bell,
  sablon: LayoutTemplate,
  entegrasyon: Plug,
  sistem: Settings,
  yedek: Database,
  geriYukleme: HardDriveDownload,
  // Felaket kurtarma yordami — destek talebiyle AYNI ikon degil.
  // Ikisi de "yardim" cagristiriyor ama biri gundelik bir istek,
  // oteki sistem cokunce acilan zarf.
  kurtarma: Siren,
  teknik: Terminal,
  etkinlik: BarChart3,
  // Kendi hesabinin ayarlari — `rol` (kalkan) DEGIL: kalkan
  // baskalarina yetki VERMEYI cagristiriyor ve bu ekranda kimse
  // baskasina dokunamiyor.
  hesap: UserCog,
  yardim: HelpCircle,
  arsiv: Archive,
  mezun: GraduationCap,

  /*
    --- HATA DEFTERI: YANLISIN BES SEBEBI (F-MST) ---
    Kapali bir sayim ve ekranda YAN YANA duruyorlar; sozlugun "ayni ikon
    iki kavrama verilmez" kurali en cok burada goze carpiyor. Cizim her
    birine ayri bir cizgi veriyor, biz de oyle.

    `defter` gezinti girdisi icin AYRI: hata defterinin KENDISI bir
    kavram, "bilgi eksigi" baskasi. Ikisini `mufredat` ile cizmek
    ekranin adiyla ekrandaki bir secenegi ayni gostermek olurdu.
  */
  defter: NotebookPen,
  /*
    `BookDashed` — KESIKLI kitap. Cizim burada duz bir kitap gosteriyor
    ama `mufredat` o cizgiyi zaten tutuyor ve sozluk ayni ikonu iki
    kavrama vermiyor (`Ikon.test.tsx` bunu olcuyor ve beni yakaladi).
    Kesiklilik anlami da tasiyor: bilgi VAR ama EKSIK — ayni doku
    `olculemedi`de de kullaniliyor.
  */
  bilgiEksigi: BookDashed,
  dikkatsizlik: MousePointerClick,
  yanlisOkuma: ScanSearch,
  islemHatasi: Calculator,
  sureYetmedi: Timer,

  // --- Durum ---
  uyari: AlertTriangle,
  // Ucgen (`uyari`) ile daire (`hata`) AYRI kavramlar: ucgen "dikkat
  // et, bir sey ters gidebilir", daire "bu deger yanlis". Form alani
  // hatasi ikincisi ve cizim paketi orada daireyi kullaniyor.
  hata: AlertCircle,
  tamam: CheckCircle2,
  bekliyor: Clock,
  bos: Inbox,
  yeni: Sparkles,
  /*
    YENI KAYIT OLUSTUR. `yeni` (parildama) ile ayni sey DEGIL ve
    ayrim sozlugun isini yapiyor: `yeni` bir seyin YENI OLDUGUNU
    soyluyor (yeni gelen talep, yeni ozellik rozeti), `ekle` ise
    kullanicinin YAPACAGI ISI. Sekiz tuvalde birincil dugmenin
    yaninda tam olarak bu arti duruyor.
  */
  ekle: Plus,
  /*
    Ileri gitme oku. Giris ekraninin "Devam" dugmesinde: ok,
    dugmenin bir SONRAKI ADIMA goturdugunu soyluyor — sifre
    ekraninda kod ekrani var, yani "Devam" gercekten devam.
  */
  sagOk: ArrowRight,
  /*
    Notr bilgi. `uyari` ile ayni yerde durabiliyor ama bambaska bir
    sey soyluyor: uyari "dikkat et", bilgi "bunu bilmen yeterli".
    Ikisini ayni ikonla cizmek, kullaniciyi her bilgi kutusunda
    tetikte olmaya iterdi ve gercek uyari kaybolurdu.
  */
  bilgi: Info,
  // "Var ama sana kapali" — oge gorunur, tiklanamaz. Paketin uc sert
  // kuralindan biri ve kilit onun tek gorsel isareti.
  kilit: Lock,
  /*
    "Olculmedi ≠ sifir" — paketin ucuncu sert kurali.
    KESIKLI daire bilerek: `yardim` (dolu daire + soru isareti) zaten
    "buradan yardim al" demek ve ayni ikonu iki kavrama vermek sozlugun
    tek isini bozar. Kesiklilik "bu deger HENUZ YOK" bilgisini bicimle
    tasiyor — renk korlugunde de okunuyor.
  */
  olculemedi: CircleDashed,

  /*
    ================================================================
    UNİKOÇ MENÜSÜ VE SATIR EYLEMLERİ — sürüm 9a (07.10.2026)
    ================================================================
    Personel paneli müşterinin eski paneline birebir getirildi
    (eski-tasarim/tarama-1.md §1.2). Oradaki menü girdileri bu sözlükte
    karşılığı olmayan kavramlar getirdi: ana sayfa (ev), çıkış, ödül
    merkezi (hediye), açılır grup oku, "Koçsapp" (sohbet balonu)...
    Mevcut kavramların ikonu DEĞİŞMEDİ; yalnızca yeni kavram eklendi.
  */
  anasayfa: House,
  menu: Menu,
  cikis: LogOut,
  hediye: Gift,
  asagiOk: ChevronDown,
  profil: CircleUser,
  sohbet: MessageCircleMore,
  gorevler: ListChecks,
  analiz: ChartNoAxesColumn,
  hedef: Target,
  canli: Radio,
  plan: ClipboardCheck,
  seans: Presentation,
  personel: Contact,
  yazismaDenetimi: MessageSquareLock,
  yonetim: Building2,
  // Satır eylemleri: göz için `gorunum` (Eye) kullanılıyor — kavram aynı, "kaydı gör".
  duzenle: SquarePen,
  indir: FileDown,
  sil: Trash2,
  // Eksik ikonlar (sürüm 9a C1): filtre kartı, liderlik, ödül merkezi girdileri.
  filtre: Funnel,
  kupa: Trophy,
  canta: ShoppingBag,
  // Bonus Çarkı: dönen döngü okları (eski panelin menü ikonu); `hedef`/`canli` ile karışmaz.
  cark: RefreshCw,
  tezgah: Store,
} as const satisfies Record<string, LucideIcon>;

export type IkonAdi = keyof typeof IKONLAR;

export interface IkonProps {
  ad: IkonAdi;
  /**
   * Olcu. Varsayilan 16px — metnin yaninda dururken satir yuksekligini
   * bozmuyor. Bos durum gorsellerinde `buyuk` kullanilir.
   */
  boyut?: "kucuk" | "normal" | "buyuk";
  className?: string;
}

const BOYUT: Record<NonNullable<IkonProps["boyut"]>, number> = {
  kucuk: 14,
  normal: 16,
  buyuk: 32,
};

/**
 * `aria-hidden` SABIT ve prop ile acilamiyor.
 *
 * Acilabilir olsaydi biri "bu ikon tek basina duruyor, okunsun" diye
 * acardi — ve o an kural delinmis olurdu. Ikon tek basina durmamali;
 * duruyorsa cozum `aria-label` degil, YANINA METIN koymak.
 *
 * Gercekten metinsiz bir dugme gerekiyorsa (mobil menu gibi) metin
 * `sr-only` olarak yazilir; ornegi `Kabuk.tsx` icinde.
 */
export function Ikon({ ad, boyut = "normal", className }: IkonProps) {
  const Cizim = IKONLAR[ad];
  const px = BOYUT[boyut];
  return (
    <Cizim
      aria-hidden="true"
      focusable="false"
      width={px}
      height={px}
      // `shrink-0`: esnek bir satirda ikon ezilmemeli. Ezilen ikon
      // orantisini kaybedip bulanik bir lekeye donusuyor.
      className={cn("shrink-0", className)}
      // Kalinlik 1.75: Lucide varsayilani 2 ve 16px'te fazla agir
      // duruyor; metin agirligiyla (500) dengelenmis hali bu.
      strokeWidth={1.75}
    />
  );
}
